import { useMemo } from "react";
import { Ic } from "../Icons";
import { ICONS } from "../iconsData";
import { useDiscussion } from "./context";
import { formatSize } from "../../utils/format";

export default function CommentAttachments({ attachments }) {
  const { openLightbox } = useDiscussion();

  const imageAtts = useMemo(
    () => (attachments || []).filter((a) => a.mime.startsWith("image/")),
    [attachments],
  );

  const handleDownloadZip = (e) => {
    e.stopPropagation();
    const ids = attachments.map((a) => a.id).join(",");
    window.location.href = `/api/v1/files/download-zip?ids=${ids}`;
  };

  if (!attachments?.length) return null;

  return (
    <div className="attachment-container">
      <div className="attachment-grid">
        {attachments.map((att) => {
          if (att.mime.startsWith("image/")) {
            const idx = imageAtts.findIndex((a) => a.id === att.id);
            return (
              <div
                key={att.id}
                className="attachment-item"
                onClick={(e) => {
                  e.stopPropagation();
                  openLightbox(imageAtts, idx);
                }}
              >
                <img
                  src={att.url}
                  alt={att.name}
                  className="attachment-thumb"
                />
                <div className="attachment-overlay">
                  <a
                    href={att.url}
                    download={att.name}
                    className="attachment-download"
                    onClick={(e) => e.stopPropagation()}
                  >
                    <Ic d={ICONS.download} size={16} />
                  </a>
                </div>
              </div>
            );
          }

          // Для всех НЕ-картинок (Excel, Word, PDF и т.д.)
          return (
            <a
              key={att.id}
              href={att.url}
              download={att.name}
              className="attachment-file-link"
              onClick={(e) => e.stopPropagation()}
              title={`Скачать ${att.name} (${formatSize(att.size)})`}
            >
              <Ic d={ICONS.file} size={16} />
              <span className="attachment-file-name">{att.name}</span>
              <Ic d={ICONS.download} size={14} className="ml-1" />
            </a>
          );
        })}
      </div>

      {attachments.length > 1 && (
        <button
          type="button"
          className="btn ghost sm mt-2"
          onClick={handleDownloadZip}
        >
          <Ic d={ICONS.download} size={14} /> Скачать всё архивом (
          {attachments.length})
        </button>
      )}
    </div>
  );
}
